// Helper utilities for adding/removing small diagnostic overlay layers (fills/lines/points)
// Keep types broad to be compatible with the MapFacade map wrappers used across the app.

import { Map } from "maplibre-gl";

export function removeLayer(map: any, id: string) {
  try {
    if (!map) return;
    if (map.getLayer && map.getLayer(id + '-fill')) map.removeLayer(id + '-fill');
    if (map.getLayer && map.getLayer(id + '-outline')) map.removeLayer(id + '-outline');
    if (map.getLayer && map.getLayer(id + '-point')) map.removeLayer(id + '-point');
    if (map.getSource && map.getSource(id)) map.removeSource(id);
  } catch (e) {
    // swallowing minor map errors here - callers can log if needed
    console.debug('removeLayer helper error', e);
  }
}

export function addPreviewLayer(map: Map, id: string, color = "#ffdd1a", color2 = "red") {
  map.addSource(id, {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] }
  });
  map.addLayer({
    id: id + "-fill",
    type: 'fill',
    source: id,
    paint: {
      'fill-color': color,
      'fill-opacity': 0.4
    },
    "filter": ['==', '$type', 'Polygon']
  });
  map.addLayer({
    id: id + "-outline",
    type: 'line',
    source: id,
    paint: {
      'line-color': color,
      'line-width': 2
    },
  });
  map.addLayer({
    id: id + "-linestring",
    type: 'line',
    source: id,
    paint: {
      'line-color': color2,
      'line-width': 2,
      'line-dasharray': [2, 2]
    }
  })
  map.addLayer({
    id: id + "-point",
    type: 'symbol',
    source: id,
    layout: {
      'icon-image': 'mit-pin-' + color,
      'icon-anchor': 'bottom',
      'icon-size': 1,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true
    },
    filter: ['==', '$type', 'Point']
  });
}

export function removePreviewLayer(map: Map, id: string) {
  map.removeLayer(id + "-fill");
  map.removeLayer(id + "-outline");
  map.removeLayer(id + "-point");
  map.removeLayer(id + "-linestring");
  map.removeSource(id);
}
export function addDisplayLayer(map: Map, id: string) {
  const color = "blue"
  map.addSource(id, {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] }
  });
  map.addLayer({
    id: id + "-fill",
    type: 'fill',
    source: id,
    paint: {
      'fill-color': color,
      'fill-opacity': 0.4
    },
    "filter": ['==', '$type', 'Polygon']
  });
  map.addLayer({
    id: id + "-outline",
    type: 'line',
    source: id,
    paint: {
      'line-color': color,
      'line-width': 2
    },
  });
  map.addLayer({
    id: id + "-point",
    type: 'symbol',
    source: id,
    layout: {
      'icon-image': 'mit-pin-' + color,
      'icon-anchor': 'bottom',
      'icon-size': 1,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true
    },
    filter: ['==', '$type', 'Point']
  });
}

export function removeDisplayLayer(map: Map, id: string) {
  map.removeLayer(id + "-fill");
  map.removeLayer(id + "-outline");
  map.removeLayer(id + "-point");
  map.removeSource(id);
}